/* eslint-disable */
import React, { Component } from 'react';
import './App.css';
import { browserHistory   } from 'react-router'
// relative path to image 
import menu from './images/menu.png';
import upload from './images/upload.png';
import result_1 from './images/result-1.png'; 
import fb from './images/f.png'; 
import tw from './images/t.png'; 
import $ from 'jquery'
import cookie from 'react-cookies'
import MetaTags from 'react-meta-tags';
import {baseURL, cmsURL} from './config';



class Result1 extends Component {

  constructor(props, context) {
      super(props, context);		
      // An instance of the Stack      
  }
 
  componentDidMount(){
	  var params = this.props.params;

	  if(params.lang===undefined){
		browserHistory.push('/my-wellness-discovery/en');
	  }		
	  $('body').addClass('body-wrap');
	  	$('body').append('<div class="preload"><div class="center"></div></div>');
      setTimeout(function() {
		$('.preload').hide(); 		
	  }, 2000);
	   
		/* Facebook Share */
		window.fbAsyncInit = function() {
			FB.init({
			  appId      : '145473506239948',
			  xfbml      : true,
			  version    : 'v2.4'
			});
		  };
		  
		  (function(d, s, id){
			 var js, fjs = d.getElementsByTagName(s)[0];
			 if (d.getElementById(id)) {return;}
			 js = d.createElement(s); js.id = id;
			 js.src = "//connect.facebook.net/en_US/sdk.js";
			 fjs.parentNode.insertBefore(js, fjs);
		   }(document, 'script', 'facebook-jssdk'));

		/* end Facebook share */
		/*---Email---*/
		var eTo = encodeURI("quiz@example.com");
		var eSubj = encodeURI("GENUINELY AUTHENTIC");
		var eBody = encodeURI("You are true to yourself and you value the real things that matters the most to you. You appreciate where you are in life now and will continue to pursue the finer things in life. Looking good as you age is important to you and you will only choose the most authentic products that promise results. You are a role model to your circle of friends.");
		var email = "mailto:" + eTo + "?subject=" + eSubj + "&body=" + eBody;
		document.getElementById("result01").href = email;
		document.getElementById("result11").href = email;
	

  }
  


  copyCurrentURL() {
	var dummy = document.createElement('input'),
		text = window.location.href;
	document.body.appendChild(dummy);
	dummy.value = text;
	dummy.select();
	document.execCommand('copy');
	document.body.removeChild(dummy);
	$(".copied").fadeIn().delay(1000).fadeOut();
 
}


sharetoTwitter(){

	var twitterWindow = window.open('https://twitter.com/share?text=You are true to yourself and you value the real things that matters the most to you. You appreciate where you are in life now and will continue to pursue the finer things in life. Looking good as you age is important to you and you will only choose the most authentic products that promise results. You are a role model to your circle of friends&url='+baseURL, 'twitter-popup', 'height=350,width=600');
		if(twitterWindow.focus) { twitterWindow.focus(); }
		return false;
	
}

sharetofacebook(){

	FB.ui({
        method: 'share_open_graph',
        action_type: 'og.shares',
        action_properties: JSON.stringify({
            object : {
               'og:url':baseURL,
               'og:title': "GENUINELY AUTHENTIC",
               'og:description': "You are true to yourself and you value the real things that matters the most to you. You appreciate where you are in life now and will continue to pursue the finer things in life. Looking good as you age is important to you and you will only choose the most authentic products that promise results. You are a role model to your circle of friends.",
               'og:og:image:width': '2560',
               'og:image:height': '960',
               'og:image': baseURL+"/result-01.png"
            }
        })
	});
	
}
  render() {

	 

	var params = this.props.params;	
	var  langObject=''
	if(params.lang==undefined){
		browserHistory.push('/my-wellness-discovery/en');
		return false;
	  }else{
		 langObject= require('./lang'+'-'+params.lang);
	  }

	 if(cookie.load("total")===undefined || cookie.load("total") < 1){
		browserHistory.push('/masj/'+params.lang);
	 } 

      return (
	 
          <div> 
       
		  <div className="animate-bkg" id="mainHolder"></div>
              <div id="viewport" className="bg-color yellow">
				<div className="header">
				  <div className="container-wrap">
					  <div className="rows"> 	  
					  <div className="col-6">
					  <div className="headMenu">
					  <a href="javascript:void(0);" className="menuIcon"><img src={menu} alt='menu'/></a>
					  <a href="javascript:void(0);" className="uploadIcon"><img src={upload} alt='upload'/></a>
					  <div className="menuDropDown">
					  <ul><li><a href={cmsURL}>{langObject.lang.home}</a></li>
					  <li><a href={cmsURL}>{langObject.lang.faq}</a></li>	
					  </ul></div>
					  <div className="socialMenu"> 
					   <ul><li><a   onClick={this.sharetofacebook.bind(this)} href="javascript:void(0);">{langObject.lang.facebook}</a></li>
					  <li><a id="result01" href="javascript:void(0);" className="twitter-share">{langObject.lang.twitter}</a></li>		
					  <li><a  onClick={this.copyCurrentURL.bind(this)} href="javascript:void(0);" ><span className="copy">{langObject.lang.copylink}</span><span className="link">{window.location.href}</span>
					  </a><span className="copied" style={{display:'none'}}>Copied</span></li>
					  </ul></div>
					  </div>
					  </div>
					   
					   
					  </div>      
				   </div>  
				</div>
				
				
				<div className="result-content">
				<div className="row-content">
				
				<div className="left-side">
				<div className="img-box">
				<img src={result_1} alt={langObject.lang.result1_title2} />
				</div>
				</div>
				
				<div className="right-side">
				
				<div className="title">
				<h4>{langObject.lang.result1_title1}</h4>
				<h2>{langObject.lang.result1_title2}</h2>
				</div>
				<p>{langObject.lang.result1}</p>
				<div className="next">
				<a href={cmsURL+"/my-wellness-discovery/"}>
				<div className="circle"></div>
				<div className="arr-text">
				<span><b>{langObject.lang.arrow_text1}</b></span>
				<span>{langObject.lang.arrow_text2}</span>
				</div>
				<div className="line-arr"></div>
				</a>
				</div>
				
				<div className="shares">
				<span>Share your Result : </span>
				<a className="facebook-share1" onClick={this.sharetofacebook.bind(this)} href="javascript:void(0);">
				<i className="fa fa-facebook" aria-hidden="true"></i></a>
				<a  id="result11" href="javascript:void(0);" className="twitter-share">
				<i className="fa fa-envelope" aria-hidden="true"></i></a>
				<p><a href={baseURL+"/masj/en"}>{langObject.lang.retake}</a></p>
				</div>	
				
				</div>
				
				</div>
				</div>
					
			   
              </div>
             
          </div>  
      )
  }
}

export default Result1;



// WEBPACK FOOTER //
// ./src/Result1.js